export const locale = {
  lang: 'en',
  data: {
    INSERT_BID: 'Insert bid',
    INVOICE_AMOUNT: 'Invoice amount',
    INVOICE_DUE_DATE: 'Due date',
    INVOICE_EXPECTED_PAYMENT_DATE: 'Expected payment date',
    SELL_NOW: 'Sell now',
    FUND: 'Fund',
    WALLET_BALANCE: 'Wallet Balance',
    VIRTUAL_BALANCE: 'Available balance',
    COMMITTED_DOWNPAYMENTS: 'Down payments due',
    DOWN_PAYMENT_AMOUNT: 'Down payment amount',
    ALERT_INSUFFICIENT_LIQUIDITY: 'Attention! The account balance is not sufficient to pay the downpayment. Contact the CashMe team for further information or make a transfer to ensure sufficient liquidity.',
    BID_INTEREST_RATE: 'Bid interest rate',
    TOS_1: 'Confermo di conoscere e accetto i',
    TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
    TOS_2: 'Confermo di conoscere e accetto le seguenti',
    TOS_2_LINK: '"Condizioni della Cessione"',
    TOS_3:
      'Accetto che il pagamento del Credito da parte del Debitore Ceduto verrà effettuato sul conto corrente bancario intestato ' +
      'all\'Istituto di Pagamento, il quale provvederà prontamente a trasferire il relativo incasso sul Conto di Pagamento del Cessionario, ' +
      'al netto del Saldo dovuto al Cedente.',
    TOS_4:
      'Accetto che CashMe, a seguito dell\'incasso di ciascun Credito da parte del l\'Istituto di Pagamento, provveda a calcolare ' +
      'l\'importo del Saldo e che l\'Istituto di pagamento stesso provveda ad utilizzare parte dell\'incasso per procedere al pagamento ' +
      'del Saldo dovuto direttamente a favore del Cedente ad eccezione delle cessioni IAS Compliant.',
    SELLER_BUSINESS_NAME: 'Seller',
    DEBTOR_BUSINESS_NAME: 'Debtor',
    DEBTOR_RATING: 'Debtor rating',
    MAX_BID_INTEREST_RATE: 'Max bid interest rate',
    VIEW_INVOICE: 'View invoice',
    VIEW_RATING: 'View rating',
    INVOICE_DETAIL: 'Invoice details',
    INSTALLMENTS_ALERT: 'This invoice includes installment payments',
    SEND: 'Send offer',
    CANCEL: 'Cancel',
    TRANSACTION_PASSWORD: 'Transaction password',
    ERROR: {
      REQUIRED: 'Value required',
      HIGH: 'Interest too high',
      WRONG_TRANSACTION_PASSWORD: 'Wrong transaction password',
      GENERAL: 'Error: bid not sent. Please retry.',
    },
    IAS_COMPLIANT_INVOICE: 'IAS Compliant transfer',
  },
};
